function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M475.64 394.262c-.098-.141-.19-.284-.281-.429L280.82 85.507c-11.531-18.27-38.154-18.24-49.667.001L35.779 395.159c-12.315 19.52 1.745 45.031 24.833 45.031h390.781c23.6 0 37.498-26.558 24.247-45.928z",
  fill: "#c6271a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.318 425.01a29.372 29.372 0 01.878-29.851l195.375-309.65a29.258 29.258 0 0113.125-11.266c-13.026-5.647-28.62-1.288-36.543 11.266L35.779 395.159c-12.315 19.52 1.745 45.031 24.833 45.031H84.03a29.368 29.368 0 01-25.712-15.18z",
  fill: "#af221b"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M451.392 471.369H60.611c-47.586 0-76.6-52.588-51.202-92.848l195.377-309.65c23.768-37.663 78.666-37.621 102.402-.002l194.387 308.082c27.097 40.081-1.794 94.418-50.183 94.418zM233.326 86.88L37.952 396.53c-11.237 17.812 1.592 41.091 22.66 41.091h390.781c21.518 0 34.227-24.218 22.137-41.894a13.827 13.827 0 01-.343-.523L278.647 86.879c-10.522-16.671-34.815-16.646-45.321.001z",
  fill: "#f74c48"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.965 378.522L225.341 68.871c9.298-14.733 24.139-24.512 40.923-27.366-24.016-4.08-48.194 6.315-61.478 27.366L9.409 378.522c-25.39 40.247 3.6 92.848 51.202 92.848h20.555c-47.585-.001-76.599-52.589-51.201-92.848z",
  fill: "#d63322"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#f2f2f2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256.001 185.261c-9.317 0-16.874 7.555-16.874 16.874v97.987c0 9.319 7.557 16.874 16.874 16.874 9.321 0 16.875-7.555 16.875-16.874v-97.987c0-9.319-7.554-16.874-16.875-16.874z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 365.23,
  r: 16.874
}));

function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.7cf8b03a.svg";
export { ForwardRef as ReactComponent };